import {DOCUMENT} from '@angular/common';
import {Component, Input, Inject, NgZone} from '@angular/core';
import {TrackingService, selectUIFeatureFlag} from '@ox/data';
import {Store} from '@ngrx/store';
import {UIFeatureFlag} from '@ox/typings';

@Component({
  selector: 'webu-chat-footer',
  templateUrl: './chat-footer.component.html'
})
export class ChatFooterComponent {
  @Input() trackingString?: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private ngZone: NgZone,
    public trackingService: TrackingService,
    private store: Store
  ) {}

  showMessageUsBtn = this.store.select(selectUIFeatureFlag({id: UIFeatureFlag.CHAT_LIVE}));

  openChat() {
    this.ngZone.runOutsideAngular(() => {
      (
        this.document
          .getElementsByClassName('LPMcontainer')
          .item(0) as HTMLElement
      ).click();
    });
  }
}
